// GA4 のセッション cookie(_ga_<測定ID の G- を除いた部分>)から session_id を取り出す。
// 問い合わせ完了をサーバー(Measurement Protocol)から送るとき、ブラウザ側のセッションに紐付けるために使う。
// 計画: docs/plans/2026-09-28-ga4-lead-session-attribution.md
//
// cookie 値の形式:
//   GS1: GS1.1.1759030000.3.1.1759030100.0.0.0           (3 番目の区切りが session_id)
//   GS2: GS2.1.s1759030000$o3$g1$t1759030100$j60$l0$h0  (s<数字> が session_id。区切りは $)

const GS2_HEAD_PATTERN = /^GS2\.\d+\.s(\d+)(?:\$|$)/
const GS2_ANY_PATTERN = /^GS2\.\d+\.(?:[^$]*\$)*?s(\d+)(?:\$|$)/
const GS1_PATTERN = /^GS\d+\.\d+\.(\d+)(?:\.|$)/

// cookie 値(デコード済み)から session_id を返す。取れなければ null。
export function sessionIdFromGa4CookieValue(value) {
  if (typeof value !== "string" || value === "") {
    return null
  }

  const gs2Match = value.match(GS2_HEAD_PATTERN) || value.match(GS2_ANY_PATTERN)
  if (gs2Match) {
    return gs2Match[1]
  }

  const gs1Match = value.match(GS1_PATTERN)
  if (gs1Match) {
    return gs1Match[1]
  }

  return null
}

// document.cookie 形式の文字列と測定ID(G-XXXX)から session_id を返す。取れなければ null。
export function sessionIdFromCookies(cookieString, measurementId) {
  if (typeof cookieString !== "string" || !measurementId) {
    return null
  }

  const cookieName = `_ga_${measurementId.replace(/^G-/, "")}=`
  const sessionCookie = cookieString
    .split("; ")
    .find((entry) => entry.startsWith(cookieName))

  if (!sessionCookie) {
    return null
  }

  let cookieValue
  try {
    cookieValue = decodeURIComponent(sessionCookie.slice(cookieName.length))
  } catch {
    return null
  }

  return sessionIdFromGa4CookieValue(cookieValue)
}
